const MiniStatsUrlParams = {
  TYPE: 'type',
} as const;

export default MiniStatsUrlParams;
